import { useEffect, useState } from "react";

/**
 * The current time for "checked … ago": taken again whenever `since` changes
 * and refreshed every `intervalMs` while `since` is set.
 */
export const useNow = (intervalMs: number, since?: number): number => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (since === undefined) return;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs, since]);
  return now;
};
